// extracted by mini-css-extract-plugin
export default {"actionButtons":"aggregatorTable_actionButtons__MUG9k","closingBalance":"aggregatorTable_closingBalance__CX9fU","alignRight":"aggregatorTable_alignRight__KdypK"};